import React, { lazy } from 'react';

// const CurrencySetupListing = lazy(() =>
//   import(
//     '@contract-root/admin-react/src/containers/SystemAdminModule/CurrencySetupModule/CurrencySetupListing'
//   ).then(module => ({
//     default: module.CurrencySetupListing,
//   })),
// );

const CurrencySetupListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/MultiCurrencyModule/MultiCurrencySettings/MultiCurrencySetup'
  ).then(module => ({
    default: module.MultiCurrencySetup,
  })),
);
const CurrencyExchangeListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/MultiCurrencyModule/MultiCurrencySettings/MultiCurrencyExchange'
  ).then(module => ({
    default: module.MultiCurrencyExchange,
  })),
);

const currencyRoutes = [
  // {
  //   props: { exact: true, path: '/:mode/general-settings/currency' },
  //   component: <CurrencyListing />,
  // },
  // {
  //   props: { exact: true, path: '/:mode/general-settings/currency-exchange' },
  //   component: <CurrencyListing />,
  // },
  {
    props: { exact: true, path: '/common-settings/currency-setup' },
    component: <CurrencySetupListing />,
  },
  {
    props: { exact: true, path: '/common-settings/currency-exchange' },
    component: <CurrencyExchangeListing />,
  },
];

export default currencyRoutes;
